module.exports = __webpack_public_path__ + "img/1.a09b3710.png";